module.exports = __webpack_public_path__ + "media/images/weather/166_night-8b1ac5bbf926a48fac3c63f85b73cb7b.png";